import { BillingWorkspace } from '@/components/billing/billing-workspace'

export function AdminBilling() {
  return <BillingWorkspace basePath="/admin/billing" />
}
